"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_swipeable_1 = require("react-swipeable");
const helpers_1 = require("../../lib/helpers");
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const useAddToForwardRef_1 = require("../../hocs/useAddToForwardRef");
const Swipe = (props) => {
    const { children, onSwipeLeft, onSwipeRight } = props;
    const containerRef = react_1.useRef(null);
    const swipeableProps = react_swipeable_1.useSwipeable({
        trackMouse: true,
        delta: 50,
        onSwipedLeft: onSwipeLeft,
        onSwipedRight: onSwipeRight,
    });
    const forwardedRef = useAddToForwardRef_1.useAddToForwardRef(props, [swipeableProps.ref, containerRef]);
    return (react_1.default.createElement("div", Object.assign({}, helpers_1.usePrimitiveProps(props), swipeableProps, { ref: forwardedRef }), children));
};
exports.default = withJourney_1.default('j-swipe', Swipe);
